import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeProps as _normalizeProps, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-869337ac"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "natural-day"
};
var _hoisted_2 = {
  class: "hostSummary"
};
var _hoisted_3 = {
  class: "num"
};
var _hoisted_4 = {
  class: "desc"
};
var _hoisted_5 = {
  class: "hostSummary"
};
var _hoisted_6 = {
  class: "mb-2 table cus-table"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("tr", {
    class: "th"
  }, [/*#__PURE__*/_createElementVNode("th", null, "标号"), /*#__PURE__*/_createElementVNode("th", null, "配比号"), /*#__PURE__*/_createElementVNode("th", null, "产量/吨"), /*#__PURE__*/_createElementVNode("th", null, "部位")], -1);
});
var _hoisted_8 = {
  key: 1
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("td", {
    colspan: "5"
  }, "暂无数据", -1);
});
var _hoisted_10 = [_hoisted_9];
var _hoisted_11 = {
  class: "hostSummary"
};
var _hoisted_12 = {
  class: "mb-2 table cus-table"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("tr", {
    class: "th"
  }, [/*#__PURE__*/_createElementVNode("th", null, "原料"), /*#__PURE__*/_createElementVNode("th", null, "重量/吨"), /*#__PURE__*/_createElementVNode("th", null, "单价/元"), /*#__PURE__*/_createElementVNode("th", null, "金额/元")], -1);
});
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("td", null, null, -1);
});
var _hoisted_15 = {
  key: 1
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("td", {
    colspan: "4"
  }, "暂无数据", -1);
});
var _hoisted_17 = [_hoisted_16];
var _hoisted_18 = {
  class: "hostSummary"
};
var _hoisted_19 = {
  class: "mb-2 table cus-table"
};
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("tr", {
    class: "th"
  }, [/*#__PURE__*/_createElementVNode("th", null, "原料"), /*#__PURE__*/_createElementVNode("th", null, "销量/吨"), /*#__PURE__*/_createElementVNode("th", null, "单价/元"), /*#__PURE__*/_createElementVNode("th", null, "金额/元")], -1);
});
var _hoisted_21 = {
  key: 1
};
var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("td", {
    colspan: "5"
  }, "暂无数据", -1);
});
var _hoisted_23 = [_hoisted_22];
var _hoisted_24 = {
  class: "hostSummary"
};
var _hoisted_25 = {
  class: "hostSummary"
};
var _hoisted_26 = {
  class: "hostSummary"
};
var _hoisted_27 = {
  class: "num"
};
var _hoisted_28 = {
  class: "desc"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_date_header_with_btn = _resolveComponent("c-date-header-with-btn");
  var _component_c_title = _resolveComponent("c-title");
  var _component_van_grid_item = _resolveComponent("van-grid-item");
  var _component_van_grid = _resolveComponent("van-grid");
  var _component_pie_echart = _resolveComponent("pie-echart");
  var _component_c_no_data = _resolveComponent("c-no-data");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_c_date_header_with_btn, {
    type: _ctx.params.type,
    showBtn: false,
    onConfirmDate: _ctx.confrimDate
  }, null, 8, ["type", "onConfirmDate"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_c_title, {
    title: "砂浆总汇"
  }), _createVNode(_component_van_grid, {
    class: "grid mb-2",
    gutter: 10,
    "column-num": 3
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryDataShangTong, function (item, index) {
        return _openBlock(), _createBlock(_component_van_grid_item, {
          key: index
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_3, _toDisplayString(item.num), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(item.desc), 1)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_c_title, {
    title: "产量总汇"
  }), _createElementVNode("table", _hoisted_6, [_hoisted_7, _ctx.mortarSumGroup.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.mortarSumGroup, function (item, index) {
    return _openBlock(), _createElementBlock("tr", {
      key: index
    }, [_createElementVNode("td", null, _toDisplayString(item.grade), 1), _createElementVNode("td", null, _toDisplayString(item.match_num), 1), _createElementVNode("td", null, _toDisplayString(item.preload), 1), _createElementVNode("td", null, _toDisplayString(item.position), 1)]);
  }), 128)) : (_openBlock(), _createElementBlock("tr", _hoisted_8, _hoisted_10))])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_c_title, {
    title: "采购总汇"
  }), _createElementVNode("table", _hoisted_12, [_hoisted_13, _ctx.receivingData.list.length ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.receivingData.list, function (item, index) {
    return _openBlock(), _createElementBlock("tr", {
      key: index
    }, [_createElementVNode("td", null, _toDisplayString(item.stone_name), 1), _createElementVNode("td", null, _toDisplayString(item.net_weight), 1), _createElementVNode("td", null, _toDisplayString(item.sale_price), 1), _createElementVNode("td", null, _toDisplayString(item.tot_money), 1)]);
  }), 128)), _createElementVNode("tr", null, [_createElementVNode("td", null, _toDisplayString(_ctx.receivingData.name), 1), _createElementVNode("td", null, _toDisplayString(_ctx.receivingData.sumWeight), 1), _hoisted_14, _createElementVNode("td", null, _toDisplayString(_ctx.receivingData.sumTotal), 1)])], 64)) : (_openBlock(), _createElementBlock("tr", _hoisted_15, _hoisted_17))])]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_c_title, {
    title: "销量总汇"
  }), _createElementVNode("table", _hoisted_19, [_hoisted_20, _ctx.saleData.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.saleData, function (item, index) {
    return _openBlock(), _createElementBlock("tr", {
      key: index
    }, [_createElementVNode("td", null, _toDisplayString(item.stone_name), 1), _createElementVNode("td", null, _toDisplayString(item.settle_value), 1), _createElementVNode("td", null, _toDisplayString(item.sale_price), 1), _createElementVNode("td", null, _toDisplayString(item.tot_money), 1)]);
  }), 128)) : (_openBlock(), _createElementBlock("tr", _hoisted_21, _hoisted_23))])]), _createElementVNode("div", _hoisted_24, [_createVNode(_component_c_title, {
    title: "砂浆一号线"
  }), _ctx.mixtureData1.pieData.length ? (_openBlock(), _createBlock(_component_pie_echart, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.mixtureData1)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1
  }))]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_c_title, {
    title: "砂浆二号线"
  }), _ctx.mixtureData2.pieData.length ? (_openBlock(), _createBlock(_component_pie_echart, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.mixtureData2)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1
  }))]), _createElementVNode("div", _hoisted_26, [_createVNode(_component_c_title, {
    title: "考勤统计"
  }), _createVNode(_component_van_grid, {
    class: "grid mb-2",
    gutter: 10,
    "column-num": 3
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendanceData, function (item) {
        return _openBlock(), _createBlock(_component_van_grid_item, {
          key: item.material_name,
          onClick: function onClick($event) {
            return _ctx.jumpPage(item.routeName);
          }
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.emptyStringFormat(item.num)), 1), _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.emptyStringFormat(item.desc)), 1)];
          }),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))];
    }),
    _: 1
  })])]);
}